import React, { useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../components/modal/Modal";
// services
import { postWhatsappConnection } from "../../services/WhatsappConnection/postWhatsappConnection";
import { getWhatsappConnections } from "../../services/WhatsappConnection/getWhatsappConnections";

const ModalConnections = ({ visible, onHide, setVisibleFacebook, onConnectionCreated, onConnectionCreatedWithId }) => {
  const [showWhatsAppOptions, setShowWhatsAppOptions] = useState(false);
  const [loadingConnection, setLoadingConnection] = useState(null);

  const shareOptions = [
    {
      id: "meta",
      label: "Meta",
      iconClass: "fa-brands fa-meta",
      color: "#1877F2",
      bgGradient: "linear-gradient(135deg, #1877F2 0%, #42A5F5 100%)",
      description: "Conecte com Facebook e Instagram"
    },
    {
      id: "whatsapp",
      label: "WhatsApp",
      iconClass: "fa-brands fa-whatsapp",
      color: "#25D366",
      bgGradient: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
      description: "Integração completa com WhatsApp"
    },
  ];

  const whatsappOptions = [
    {
      id: "cobranca",
      label: "Cobrança",
      iconClass: "fa-solid fa-receipt",
      color: "#FF6B35",
      bgGradient: "linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)",
      description: "Automatize cobranças via WhatsApp"
    },
    {
      id: "cadastro-rapido",
      label: "Cadastro Rápido",
      iconClass: "fa-solid fa-user-plus",
      color: "#00BCD4",
      bgGradient: "linear-gradient(135deg, #00BCD4 0%, #26C6DA 100%)",
      description: "Facilite o cadastro de clientes"
    },
    {
      id: "crm",
      label: "CRM",
      iconClass: "fa-solid fa-chart-line",
      color: "#9C27B0",
      bgGradient: "linear-gradient(135deg, #9C27B0 0%, #AB47BC 100%)",
      description: "Gerencie relacionamentos com clientes"
    },
  ];

  const handleOptionClick = (type) => {
    console.log("Selected option:", type);
    switch (type) {
      case "meta":
        setVisibleFacebook(true);
        break;
      case "whatsapp":
        setShowWhatsAppOptions(true);
        break;
      case "instagram":
        console.log("Instagram connection.");
        break;
      default:
        console.log("Unknown option selected.");
    }
  };

  const handleWhatsAppOptionClick = async (type) => {
    console.log("Selected WhatsApp option:", type);
    
    if (type === "crm") {
      setLoadingConnection("crm");
      const toastId = toast.loading("Criando conexão WhatsApp...");
      
      try {
        const response = await postWhatsappConnection();
        
        if (response && response.statusCode === 201) {
          toast.update(toastId, {
            render: response.message || "Conexão criada com sucesso!",
            type: "success",
            isLoading: false,
            autoClose: 2000,
          });
          
          if (onConnectionCreated) {
            onConnectionCreated();
          }
          
          try {
            const connectionsResponse = await getWhatsappConnections();
            if (connectionsResponse?.data && connectionsResponse.data.length > 0) {
              const sortedConnections = connectionsResponse.data.sort((a, b) => 
                new Date(b.created_at) - new Date(a.created_at)
              );
              const newestConnection = sortedConnections[0];
              
              if (onConnectionCreatedWithId) {
                onConnectionCreatedWithId(newestConnection.id);
              }
            }
          } catch (fetchError) {
            console.error("Erro ao buscar conexões após criação:", fetchError);
          }
          
          onHide();
        } else {
          throw new Error("Erro inesperado ao criar conexão");
        }
      } catch (error) {
        console.error("Erro ao criar conexão:", error);
        toast.update(toastId, {
          render: "Erro ao criar conexão do WhatsApp",
          type: "error",
          isLoading: false,
          autoClose: 4000,
        });
      } finally {
        setLoadingConnection(null);
      }
    } else {
      switch (type) {
        case "cobranca":
          console.log("WhatsApp Cobrança connection.");
          break;
        case "cadastro-rapido":
          console.log("WhatsApp Cadastro Rápido connection.");
          break;
        default:
          console.log("Unknown WhatsApp option selected.");
      }
    }
  };

  const handleBackToMain = () => {
    setShowWhatsAppOptions(false);
  };

  return (
    <Modal
      visible={visible}
      dynamicTitle={showWhatsAppOptions ? "Opções do WhatsApp" : "Escolha o tipo de conexão"}
      onHide={onHide}
      closable={true}
    >
      <div className="row p-3 justify-content-center modal-switch">
        {showWhatsAppOptions && (
          <div className="col-12 d-flex justify-content-start mb-4 text-center">
            <button
              onClick={handleBackToMain}
              className="btn btn-outline-secondary btn-lg px-4 py-2"
              style={{ 
                borderRadius: "25px",
                transition: "all 0.3s ease",
                border: "2px solid #6c757d"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#6c757d";
                e.target.style.color = "white";
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 4px 12px rgba(108, 117, 125, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#6c757d";
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "none";
              }}
            >
              <i className="fa-solid fa-arrow-left me-2"></i>
              Voltar para conexões
            </button>
          </div>
        )}
        
        {showWhatsAppOptions
          ? whatsappOptions.map((option) => (
              <div key={option.id} className="col-lg-4 col-md-6 col-sm-12 my-3">
                <div
                  onClick={() => !loadingConnection && handleWhatsAppOptionClick(option.id)}
                  className="card h-100 shadow-lg border-0"
                  style={{ 
                    borderRadius: "20px", 
                    cursor: loadingConnection ? "not-allowed" : "pointer",
                    background: option.bgGradient,
                    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                    overflow: "hidden",
                    position: "relative",
                    opacity: loadingConnection && loadingConnection !== option.id ? 0.5 : 1
                  }}
                  onMouseEnter={(e) => {
                    if (!loadingConnection) {
                      e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                      e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.2)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!loadingConnection) {
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
                    }
                  }}
                >
                  <div 
                    className="card-body d-flex flex-column align-items-center justify-content-center text-white p-4"
                    style={{ minHeight: "200px" }}
                  >
                    <div 
                      className="icon-container mb-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(10px)",
                        border: "2px solid rgba(255,255,255,0.3)"
                      }}
                    >
                      {loadingConnection === option.id ? (
                        <div 
                          className="spinner-border text-white" 
                          role="status"
                          style={{ width: "35px", height: "35px" }}
                        >
                          <span className="visually-hidden">Criando...</span>
                        </div>
                      ) : (
                        <i 
                          className={option.iconClass} 
                          style={{ fontSize: "35px", color: "white" }}
                        ></i>
                      )}
                    </div>
                    <h3 className="mb-2 text-center fw-bold">
                      {loadingConnection === option.id ? "Criando..." : option.label}
                    </h3>
                    <p className="text-center mb-0 opacity-90" style={{ fontSize: "14px" }}>
                      {loadingConnection === option.id ? "Aguarde..." : option.description}
                    </p>
                  </div>
                  {!loadingConnection && (
                    <div 
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <i className="fa-solid fa-arrow-right" style={{ fontSize: "12px", color: "white" }}></i>
                    </div>
                  )}
                </div>
              </div>
            ))
          : shareOptions.map((option) => (
              <div key={option.id} className="col-lg-6 col-md-6 col-sm-12 my-3">
                <div
                  onClick={() => handleOptionClick(option.id)}
                  className="card h-100 shadow-lg border-0"
                  style={{ 
                    borderRadius: "20px", 
                    cursor: "pointer",
                    background: option.bgGradient,
                    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                    overflow: "hidden",
                    position: "relative"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px) scale(1.02)";
                    e.currentTarget.style.boxShadow = "0 20px 40px rgba(0,0,0,0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)";
                  }}
                >
                  <div 
                    className="card-body d-flex flex-column align-items-center justify-content-center text-white p-5"
                    style={{ minHeight: "250px" }}
                  >
                    <div 
                      className="icon-container mb-4"
                      style={{
                        width: "100px",
                        height: "100px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backdropFilter: "blur(10px)",
                        border: "2px solid rgba(255,255,255,0.3)"
                      }}
                    >
                      <i 
                        className={option.iconClass} 
                        style={{ fontSize: "45px", color: "white" }}
                      ></i>
                    </div>
                    <h2 className="mb-3 fw-bold">{option.label}</h2>
                    <p className="text-center mb-0 opacity-90">
                      {option.description}
                    </p>
                  </div>
                  <div 
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "15px",
                      width: "35px",
                      height: "35px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <i className="fa-solid fa-arrow-right" style={{ fontSize: "14px", color: "white" }}></i>
                  </div>
                </div>
              </div>
            ))
        }
      </div>
    </Modal>
  );
};

export default ModalConnections;
